import React from "react";
import Q from "q";
import trim from "lodash/trim";
import isValidDate from "./validDate";
//import CreditCardValidator from 'card-validator';
import Cookies from "universal-cookie";
import Customer from "Services/http/customer";
import T from "Translate";
import store from "Store";
import { isPossiblePhoneNumber } from "react-phone-number-input";

const validations = {
    composeValidators:
        (...validators) =>
        value => {
            return validators.reduce((error, validator) => error || validator(value), undefined);
        },
    required: value => {
        return value ? undefined : <T>{"error_required_field"}</T>;
    },
    requiredPhone: (value = "") => {
        if (value.trim().length <= 3) {
            return <T>{"error_required_field"}</T>;
        }
    },
    isPossiblePhoneNumber: (value = "") => {
        if (!isPossiblePhoneNumber(value)) {
            return <T>{"error_invalid_phone"}</T>;
        }
    },
    checkboxRequired: value => {
        return value ? undefined : <T>{"error_make_checkbox"}</T>;
    },
    numericOnly: value => {
        return trim(value) && isNaN(value) ? <T>{"error_only_number"}</T> : undefined;
    },
    maxLength: max => value => {
        return trim(value) && trim(value).length > max ? <T value={max}>{"error_maxlength_chars"}</T> : undefined;
    },
    minDigits: min => value => {
        return trim(value) && trim(value).length < min ? <T value={min}>{"error_minimum_digits"}</T> : undefined;
    },
    minLength: (min, overrideMessage) => value => {
        return trim(value) && trim(value).length < min ? (
            overrideMessage ? (
                <T>{overrideMessage}</T>
            ) : (
                <T value={min}>{"error_minimum_chars"}</T>
            )
        ) : undefined;
    },
    validName: value => {
        const isChinese = ["HK", "TW"];
        if (isChinese.includes(store.getState().locale.country)) {
            //\u2E80-\u2FD5\u3400-\u4DBF\u4E00-\u9FCC zh-CN
            return trim(value) && !value.match(/^[a-zA-Z. ']*$/) ? (
                <T>{"error_name_only_eng"}</T>
            ) : undefined;
        }
        return trim(value) && !value.match(/^[a-zA-Z-. '\u00C0-\u017F\u0621-\u064A\u0660-\u0669]*$/) ? (
            <T>{"error_name"}</T>
        ) : undefined;
    },
    validFullName: value => {
        if (store.getState().locale.country === "TH")
            return trim(value) && !value.match(/^[ก-ฮ\s]+$/) ? <T>{"error_fullname_th"}</T> : undefined;
        return trim(value) && !value.match(/^[a-zA-Z-. '\u00C0-\u017F\u0621-\u064A\u0660-\u0669]*$/) ? (
            <T>{"error_name"}</T>
        ) : undefined;
    },
    validDate: format => value => {
        return trim(value) && !isValidDate(value, format) ? <T>{"error_valid_date"}</T> : undefined;
    },
    validPhone: format => value => {
        return trim(value) && !value.match(/^[0-9]*$/) ? <T>{"error_invalid_phone"}</T> : undefined;
    },
    validEmail: value => {
        if (trim(value) && (!value.match(/^\w+([\\+.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/) || value.length > 40)) {
            return <T>{"error_valid_email"}</T>;
        }

        return undefined;
    },
    validPassword: value => {
        return trim(value) && !value.match(/^[A-z0-9*.!@#$%^&(){}[\]:;<>,.?/~_+\-=\\|]*$/) ? (
            <T>{"invalid_character"}</T>
        ) : undefined;
    },
    validAddress: value => {
        return trim(value) && !value.match(/^[a-zA-Z'\d\s/-_(),#.\u0621-\u064A\u0660-\u0669]*$/) ? undefined : undefined;
    },
    /*validCreditCard: value => {
    return trim(value) && !CreditCardValidator.number(value).isValid ? <T>{"error_invalid_cc"}</T> : undefined;
  },*/
    validCCdate: value => {
        return trim(value) ? undefined : undefined;
    },
    validDistId: value => {
        return trim(value) && isNaN(value) ? <T>{"please_en_val_id"}</T> : verifyDistId(value);
    },
    emailNotTaken: async value => {
        const res = await Customer.checkEmailAddressExist(value);

        if (!res.data || !res.data.data || !res.data.data.error) {
            return <T>duplicate_email</T>;
        }

        return;
    },
    removeRef: value => {
        const cookies = new Cookies();
        cookies.set("refEnrollerName", "", { path: "/" });
        return "";
    },
    hasUpperCase: value => {
        return trim(value) && !value.match(/[A-Z]/) ? <T>{"error_uppercase"}</T> : undefined;
    },
    hasLowerCase: value => {
        return trim(value) && !value.match(/[a-z]/) ? <T>{"error_lowercase"}</T> : undefined;
    },
    hasNumber: value => {
        return trim(value) && !value.match(/\d/) ? <T>{"error_number"}</T> : undefined;
    },
    hasSpecialChar: value => {
        return trim(value) && !value.match(/[*.!@#$%^&(){}[\]:;<>,.?/~_+\-=\\|]/) ? (
            <T>{"error_special_char"}</T>
        ) : undefined;
    }
};

export const verifyDistId = values => {
    let defer = Q.defer();
    Customer.getDistributorDetails(values)
        .then(res => {
            if (res.data.data.items !== undefined) {
                defer.resolve("undefined");
            } else {
                defer.resolve(<T>{"please_en_val_id"}</T>);
            }
        })
        .catch(err => {
            defer.reject(<T>{"please_en_val_id"}</T>);
        });
    return defer;
};

export default validations;



// WEBPACK FOOTER //
// ./src/components/Common/Validation/Validation.js